const ar = {
  // ── Sections shared by more than one page ────────────────────────────────
  process: {
    eyebrow: "مسار التعلّم لدينا",
    title: "مسار تعلّم يُبنى حولك",
    aside:
      "كل متعلّم مختلف. نلتقي بك عند نقطة انطلاقك ونبني مسارًا من أول سطر شيفرة تكتبه إلى الإتقان الفعلي.",
    steps: [
      {
        title: "التقييم",
        body: "نقيّم مستواك الحالي ونصمّم الدورة حول أهدافك، من المبرمجين لأول مرة إلى المطوّرين العاملين.",
      },
      {
        title: "التعلّم",
        body: "جلسات مباشرة وتطبيقية مع توجيه فوري ومشاريع مستمدّة من عمل هندسي حقيقي.",
      },
      {
        title: "الإتقان",
        body: "ملاحظات ودعم متواصلان بينما تصقل مهاراتك وتبدأ في تطبيقها بنفسك.",
      },
    ],
  },

  whyChoose: {
    eyebrow: "لماذا تختارنا",
    title: "الفرق يكمن في طريقة تدريسنا",
    items: [
      {
        title: "مدرّبون خبراء",
        body: "مهندسو برمجيات عاملون يدرّسون. كل مدرّب كتب شيفرة إنتاجية ويجلب تلك الخبرة إلى قاعة الدرس.",
      },
      {
        title: "تعلّم بوتيرتك",
        body: "تتكيّف الدورات مع أهدافك ووتيرتك، كي تقضي وقتك على المادة التي تدفعك إلى الأمام.",
      },
      {
        title: "نتائج مثبتة",
        body: "يخرج المتعلّمون قادرين على البناء. تعني الصيغة التطبيقية أنك تمارس المهارة التي أتيت من أجلها، لا أن تقرأ عنها فقط.",
      },
    ],
  },

  // ── Home ─────────────────────────────────────────────────────────────────
  home: {
    metaTitle: "SkillSynergy | دورات مباشرة في البرمجة والذكاء الاصطناعي",
    metaDescription:
      "دورات مباشرة وتطبيقية في البرمجة والذكاء الاصطناعي لكل المستويات. تعلّم هندسة البرمجيات خطوة بخطوة مع مدرّبين خبراء، في حصص جماعية أو فردية.",

    hero: {
      badge: "دورات مباشرة عبر الإنترنت",
      titleLine1: "من المبتدئ",
      titleLine2: "إلى المحترف. أتقن",
      titleCoding: "البرمجة",
      titleAnd: "و",
      titleAi: "الذكاء الاصطناعي",
      lead: "دورات برمجة مباشرة وتطبيقية لكل المستويات، تشمل الآن الذكاء الاصطناعي وتعلّم الآلة. تعلّم خطوة بخطوة مع مدرّبين خبراء وابنِ ثقة حقيقية.",
      rating: "محبوبة من المتعلّمين حول العالم",
      yearsValue: "+10",
      yearsLabel: "سنوات خبرة",
      imageAlt: "مدرّب يوجّه طالبًا خلال كتابة الشيفرة على حاسوب محمول",
    },

    aiSpotlight: {
      badge: "دورة جديدة",
      titlePre: "تعلّم",
      titleAi: "الذكاء الاصطناعي",
      titlePost: "وتعلّم الآلة",
      body: "أكثر المهارات طلبًا في مجال التقنية، تُدرَّس مباشرةً وتطبيقيًا. انتقل من أسس تعلّم الآلة إلى إطلاق تطبيقات حقيقية بالنماذج اللغوية الكبيرة ووكلاء الذكاء الاصطناعي.",
      exploreCta: "استكشف دورة الذكاء الاصطناعي",
    },

    skills: {
      eyebrow: "ما ستتقنه",
      title: "مهارات تبني مسارات مهنية حقيقية",
    },

    pricing: {
      eyebrow: "الأسعار والباقات",
      title: "باقات بسيطة، تقدّم جادّ",
    },

    cta: {
      title: "ابنِ مهارات برمجية حقيقية مع الدورات المباشرة",
      body: "احجز استشارة مجانية وسنساعدك على اختيار المسار المناسب.",
    },
  },

  // ── Courses index ────────────────────────────────────────────────────────
  coursesPage: {
    metaTitle: "SkillSynergy | الدورات",
    metaDescription:
      "دورات برمجة فردية وجماعية عبر الإنترنت لجميع المستويات، عبر مسارات تعلّم مرنة ومنظّمة بكثافات متفاوتة.",

    eyebrow: "كتالوج الدورات",
    title: "دورات مبنية لتقدّم حقيقي",
    lead: "دورات برمجة فردية وجماعية عبر الإنترنت لجميع المستويات، عبر مسارات تعلّم مرنة ومنظّمة بكثافات متفاوتة.",
    statCoursesValue: "7",
    statCoursesLabel: "دورات متاحة",
    statYearsValue: "+10",
    statYearsLabel: "سنوات خبرة",
    coreTitle: "دوراتنا الأساسية",
    heroImageAlt: "طلاب يعملون معًا على تمرين برمجي",
  },

  // ── Course detail ────────────────────────────────────────────────────────
  coursePage: {
    curriculumEyebrow: "المنهج",
    curriculumTitle: "ما ستتعلّمه",
    aboutTitle: "حول هذه الدورة",
    exploreOthers: "استكشف دورات أخرى",
    readyTitle: (course: string) => `مستعد لبدء ${course}؟`,
    readyBody: "احجز استشارة مجانية واحصل على خطة مصمّمة خصيصًا لك.",
  },

  // ── About ────────────────────────────────────────────────────────────────
  about: {
    metaTitle: "SkillSynergy | من نحن",
    metaDescription:
      "تقدّم SkillSynergy دورات برمجة مباشرة وتفاعلية لمتعلّمين من كل المستويات، بمن فيهم المبتدئون تمامًا. حصص صغيرة يدرّسها مهندسون عاملون.",

    eyebrow: "عن SkillSynergy",
    title: "نعلّم الناس كتابة برمجيات حقيقية",
    lead: "دورات برمجة مباشرة وتفاعلية مصمّمة لمتعلّمين من كل المستويات، حتى من الصفر.",
    storyEyebrow: "عن SkillSynergy",
    storyTitle: "دليلك الموثوق إلى البرمجة",
    storyBody1:
      "تقدّم SkillSynergy دورات برمجة مباشرة وتفاعلية لمتعلّمين من كل المستويات، بمن فيهم المبتدئون تمامًا. الحصص صغيرة وتطبيقية ويدرّسها مهندسون عاملون.",
    storyBody2:
      "الهدف واضح: تنهي الدورة قادرًا على بناء البرمجيات بنفسك، ويكون لديك من تسأله حين تتعثّر.",
    cta: {
      title: "لنبنِ مهاراتك معًا",
      body: "تعلّم إلى جانب أشخاص آخرين، بتوجيه من الخبراء.",
    },
    imageAlt: [
      "طالب يبرمج بشكل ثنائي على حاسوب محمول",
      "مدرّب يراجع الشيفرة على لوح أبيض",
      "مجموعة دراسة تعمل على حلّ تمرين",
    ],
    storyImageAlt: "مطوّر يعالج مشكلة على حاسوب محمول",
  },

  // ── Pricing ──────────────────────────────────────────────────────────────
  pricingPage: {
    metaTitle: "SkillSynergy | الأسعار",
    metaDescription:
      "اختر حصة جماعية للتعلّم التعاوني، أو انتقل إلى المسار الفردي لإرشاد شخصي متكامل. مسارات خفيفة وشبه مكثّفة ومكثّفة.",

    offerBadge: (offer: string) =>
      `عرض الإطلاق · خصم ${offer}% للمسجلين الأوائل`,
    title: "نقدّم لك أفضل الأسعار",
    lead: "اختر حصة جماعية للتعلّم التعاوني، أو انتقل إلى المسار الفردي لإرشاد شخصي متكامل.",
    perMonth: "/شهريًا",
    priceNote:
      "جميع الأسعار شهرية وتشمل ضريبة القيمة المضافة حيثما تنطبق. بدون رسوم تسجيل.",
    popular: "الأكثر رواجًا",
    group: "جماعي",
    individual: "فردي",
    planLabel: "خطة الفوترة",
    cta: {
      title: "لست متأكدًا من الباقة المناسبة؟",
      body: "احجز استشارة مجانية وسنوصي بالمسار المناسب لأهدافك.",
    },
  },

  // ── Contact ──────────────────────────────────────────────────────────────
  contact: {
    metaTitle: "SkillSynergy | تواصل",
    metaDescription:
      "تواصل معنا وسيساعدك فريقنا على إيجاد الدورة المناسبة والبدء. نردّ عادةً خلال يوم عمل واحد.",

    eyebrow: "تواصل معنا",
    title: "تريد معرفة المزيد عن دوراتنا؟",
    lead: "تواصل معنا وسيساعدك فريقنا على إيجاد الدورة المناسبة والبدء. نردّ عادةً خلال يوم عمل واحد.",
    phone: "الهاتف",
    email: "البريد الإلكتروني",
    location: "الموقع",
    formTitle: "أرسل لنا رسالة",
    fullName: "الاسم الكامل",
    fullNamePlaceholder: "جين دو",
    emailLabel: "البريد الإلكتروني",
    emailPlaceholder: "jane@email.com",
    subject: "الموضوع",
    subjectPlaceholder: "استفسار عن دورة",
    message: "الرسالة",
    messagePlaceholder: "أخبرنا عن أهدافك...",
    send: "إرسال الرسالة",
    sending: "جارٍ الإرسال…",
    successTitle: "تم إرسال الرسالة",
    successBody: "شكرًا لتواصلك. سنردّ خلال يوم عمل واحد.",
    error: "لم تكتمل العملية. يُرجى المحاولة مرة أخرى أو مراسلتنا مباشرة.",
  },
};

export default ar;
